import { IFormValuesProfile } from '../components/modals/editProfile/types';
import {
  ICreatePassword, IGetPromiseOpportunities, IGetPromiseOpportunitiesById,
  IGetPromiseProfile,
  ILoginUser, IResetPassword, IReturnPromise, IReturnPromiseOpportunities,
  IReturnPromiseProfile,
  IReturnPromiseQualification,
  IReturnPromiseVerify, IReturnPromiseVolunteers, IVerifyCode,
} from '../models/service/service';
import { IFormValues } from '../pages/createOpportunity/types';
import { fetchRequest } from '../utils/request';

const base_url = window.location.origin.includes('localhost')
  || window.location.origin.includes('dev')
  || window.location.origin.includes('3.229.7.109')
  ? 'http://3.229.7.109:3000/api/v1/organization'
  : 'https://letsdugood.org.au/api/v1/organization';

const maps_url = window.location.origin.includes('localhost')
  || window.location.origin.includes('dev')
  || window.location.origin.includes('3.229.7.109')
  ? 'http://3.229.7.109:3000/api/v1/maps'
  : 'https://letsdugood.org.au/api/v1/maps';

const endpoints = {
  profile: '/profile',
  login: '/auth/login',
  logout: '/auth/logout',
  refresh: '/auth/refresh',
  opportunities: '/opportunities',
  resetPassword: '/auth/reset-password',
  volunteers: '/opportunities/volunteers',
  createPassword: '/auth/create-password',
  verifyCode: '/auth/verify-reset-password',
  requiredQualification: '/opportunities/required-qualification',
};

export class OrganizerService {

  static $isLoggedIn(): boolean {
    return localStorage.isAuth && localStorage.token;
  }

  static $logoutUser(): Promise<IReturnPromise> {
    return fetchRequest(base_url + endpoints.logout, { method: 'POST' });
  }

  static $refresh(): Promise<IReturnPromise> {
    return fetchRequest(base_url + endpoints.refresh, { method: 'POST' });
  }

  static $getProfile(): Promise<IGetPromiseProfile> {
    return fetchRequest(base_url + endpoints.profile, { method: 'GET' });
  }

  static $getOpportunities(): Promise<IGetPromiseOpportunities> {
    return fetchRequest(base_url + endpoints.opportunities, { method: 'GET' });
  }

  static $getOpportunitiesById(id: string | null): Promise<IGetPromiseOpportunitiesById> {
    return fetchRequest(`${base_url}${endpoints.opportunities}/${id}`, { method: 'GET' });
  }

  static $getRequiredQualification(): Promise<IReturnPromiseQualification> {
    return fetchRequest(base_url + endpoints.requiredQualification, { method: 'GET' });
  }

  static $deleteOpportunities(id: string | null): Promise<IReturnPromise> {
    return fetchRequest(`${base_url}${endpoints.opportunities}/${id}`, { method: 'DELETE' });
  }

  static $loginUser(data: ILoginUser): Promise<IReturnPromise> {
    return fetchRequest(base_url + endpoints.login, { method: 'POST', body: JSON.stringify(data) });
  }

  static $verifyCode(data: IVerifyCode): Promise<IReturnPromiseVerify> {
    return fetchRequest(base_url + endpoints.verifyCode, { method: 'POST', body: JSON.stringify(data) });
  }

  static $resetPassword(data: IResetPassword): Promise<IReturnPromise> {
    return fetchRequest(base_url + endpoints.resetPassword, { method: 'POST', body: JSON.stringify(data) });
  }

  static $getVolunteers(id: string | null, skip = 0, limit = 10): Promise<IReturnPromiseVolunteers> {
    return fetchRequest(`${base_url}${endpoints.volunteers}/${id}?skip=${skip}&limit=${limit}`, { method: 'GET' });
  }

  static $createOpportunities(data: IFormValues): Promise<IReturnPromiseOpportunities> {
    return fetchRequest(base_url + endpoints.opportunities, { method: 'POST', body: JSON.stringify(data) });
  }

  static $createPassword(data: ICreatePassword): Promise<IReturnPromise> {
    return fetchRequest(base_url + endpoints.createPassword, { method: 'POST', body: JSON.stringify(data) });
  }

  static $editProfile(data: IFormValuesProfile): Promise<IReturnPromiseProfile> {
    return fetchRequest(base_url + endpoints.profile, { method: 'PATCH', body: JSON.stringify(data) });
  }

  static $editOpportunities(data: IFormValues, id: string | null): Promise<IReturnPromiseOpportunities> {
    return fetchRequest(`${base_url}${endpoints.opportunities}/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
  }

  static $rejectVolunteer(opportunityId: string | null, volunteerId: string): Promise<IReturnPromise> {
    return fetchRequest(`${base_url}${endpoints.opportunities}/${opportunityId}/volunteer/${volunteerId}`, { method: 'DELETE' });
  }

  static $mapsAutocomplete(search: string) {
    return fetchRequest(`${maps_url}/autocomplete?search=${search}`);
  }

}
